module.exports = __webpack_public_path__ + "img/04.ac72f5db.jpg";